class Orders {
  update_selected_panel(panel) {
    this.panels.removeClass('box-shadow-colored');
    panel.addClass('box-shadow-colored');
    $('#total').text(panel.data('price'));
    $('#subscription-setup-fee').toggleClass('d-none', !(panel.data('setup-fee') > 0));

    var public_trial = panel.data('public-trial') === true;
    $('.only-with-trials').toggleClass('d-none', !public_trial);
    $('.only-with-trials [data-required-for-trial]').prop('required', public_trial);
  }

  init() {
    this.panels = $('.provider-subscription-panel');
    var selected_panel = this.panels.has('input:radio:checked');
    this.update_selected_panel(selected_panel);
  }

  option_panel_click_handler() {
    this.panels.off('click.orders').on('click.orders', (e) => {
      var panel = $(e.currentTarget);
      panel.find('input:radio').prop('checked', true);
      this.update_selected_panel(panel);
    });
  }
}

$(document).on('turbo:render', function() {
  // Handle 422 response on form submit error (turbo:load does not fire on 4xx)
  if ($("body.orders.create").length == 0) {
    return;
  }
  console.log("page render in orders.js");

  var orders = new Orders();
  orders.init();
  orders.option_panel_click_handler();
});

$(document).on('turbo:load', function() {
  if ($("body.orders.new").length == 0 && $("body.orders.create").length == 0) {
    return;
  }
  console.log("page load in orders.js");


  var orders = new Orders();
  orders.init();
  orders.option_panel_click_handler();
});
